import http from 'lib/utils/axios';
import serializeParams from 'lib/utils/url';

const PROJECT_URL = '/project';

export const getLanguages = async() => {
  try {
    const { data } = await http.get(`${PROJECT_URL}/languages`);

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

/*
  language - передается строковый код языка
  projectCode - код проекта
  billCode - идентификатор счета
  publicId - идентификатор платежа
*/
export const getLocale = async(params) => {
  try {
    const { data } = await http.get(`${PROJECT_URL}/locale?${serializeParams(params)}`);

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
